(function ($) {
    jQuery.widget("nsp.asideMenu", {
        options: {},
        _scrollingFromClick: false,

        _setOption: function (key, value) {
            this.options[key] = value;
            this._update();
        },

        _create: function () {
            this._initVars();
            this._initClickHandlers();
            this._initPanelSwitchHandler();
            this._bindScrollHandler();
            this._scrollingFromClick = true;

            setTimeout(() => {
                this._setDefaultActiveState();
                this._stickyMenu();
                this._handleInitialHash();
                this._checkActiveSection();
            }, 100);
        },

        _bindScrollHandler: function () {
            let scrollTimeout = null;
            $(window).on("scroll", () => {
                if (scrollTimeout) {
                    clearTimeout(scrollTimeout);
                }
                scrollTimeout = setTimeout(() => {
                    this._checkActiveSection();
                }, 16);
            });
        },

        _initPanelSwitchHandler: function () {
            if (this.menuType !== "services") return;

            $(document).on("services-panel-changed", () => {
                this._updateAllServiceMenus();
            });
        },

        _updateAllServiceMenus: function () {
            const $serviceAsides = $(".s-services__aside");

            $serviceAsides.each((index, element) => {
                const $aside = $(element);
                const $panel = $aside.closest(".s-services__panel");
                const asideMenuWidget = $aside.data("nsp-asideMenu");

                if ($panel.hasClass("is-visible")) {
                    this._setServiceActiveStateFromHashOrDefault($aside, $panel);
                    if (asideMenuWidget) {
                        asideMenuWidget.reinitializeSticky();
                    }
                } else {
                    this._detachSticky($aside);
                }
            });
        },

        _resetActiveState: function ($aside) {
            const $links = $aside.find("a");
            $links.removeClass("is-active");
            $links.first().addClass("is-active");
        },

        _detachSticky: function ($aside) {
            if ($aside.data("sticky_kit")) {
                $aside.trigger("sticky_kit:detach");
            }
        },

        _setDefaultActiveState: function () {
            if (this.menuType === "services") {
                this._setServiceActiveStateFromHashOrDefault(this.element, this.element.closest(".s-services__panel"));
                return;
            }

            if (!window.location.hash) {
                this._setAboutDefaultActiveState();
            }
        },

        _setAboutDefaultActiveState: function (attempt = 0) {
            const maxAttempts = 12;
            const $links = this.element.find("li a");

            if (!$links.length) {
                if (attempt < maxAttempts) {
                    setTimeout(() => this._setAboutDefaultActiveState(attempt + 1), 50);
                }
                return;
            }

            this.element.find("li, li a").removeClass("active");

            const $firstLink = $links.first();
            $firstLink.addClass("active");
            $firstLink.closest("li").addClass("active");
        },

        _setServiceActiveStateFromHashOrDefault: function ($aside, $panel) {
            const $links = $aside.find("a");

            if (!$links.length) return;

            const $activeLink = this._getServiceLinkFromHash($aside, $panel);

            if ($activeLink.length) {
                $links.removeClass("is-active");
                $activeLink.addClass("is-active");
                return;
            }

            this._resetActiveState($aside);
        },

        _getServiceLinkFromHash: function ($aside, $panel) {
            const hash = window.location.hash;

            if (!hash || hash.charAt(0) !== "#" || hash.length <= 1 || !$panel.length) {
                return $();
            }

            const $targetSection = $(hash);
            const $targetPanel = $targetSection.closest(".s-services__panel");

            if (!$targetSection.length || !$targetPanel.length || $targetPanel[0] !== $panel[0]) {
                return $();
            }

            return $aside.find(`a[href="${hash}"]`);
        },

        _initClickHandlers: function () {
            this.hrefs.on("click", (e) => {
                e.preventDefault();

                const $target = $(e.currentTarget);
                const targetId = $target.attr("href");
                if (!targetId || targetId.charAt(0) !== "#" || targetId.length <= 1) return;

                const $targetSection = $(targetId);

                if ($targetSection.length) {
                    const targetHash = targetId.substring(1);
                    this._scrollingFromClick = true;
                    this._updateActiveState(targetHash);
                    this._smoothScrollToSection($targetSection, () => {
                        this._scrollingFromClick = false;
                    });
                    if (history.pushState) {
                        history.pushState(null, "", targetId);
                    }
                }
            });
        },

        _handleInitialHash: function () {
            const hash = window.location.hash;
            const $section = hash ? $(hash) : null;

            if (!$section || !$section.length) {
                this._scrollingFromClick = false;
                return;
            }

            const sectionId = hash.substring(1);
            const offsetTop = $section.offset().top - api.fn.getHeaderHeight() - 20;

            this._updateActiveState(sectionId);
            window.scrollTo(0, offsetTop);

            setTimeout(() => {
                this._scrollingFromClick = false;
            }, 50);
        },

        _smoothScrollToSection: function ($section, callback) {
            const offsetTop = $section.offset().top - api.fn.getHeaderHeight() - 20;

            $("html, body").animate({ scrollTop: offsetTop }, 800, "easeInOutQuart", callback);
        },

        _initVars: function () {
            this.wrap = this.element;
            this.menuType = this._detectMenuType();
            this.hrefs = this._getMenuLinks();
            this.ul = this.menuType === "about" ? $("ul", this.wrap) : null;
        },

        _detectMenuType: function () {
            if (this.element.hasClass("b-aside-menu")) return "about";
            if (this.element.hasClass("s-services__aside")) return "services";

            console.warn("AsideMenu widget initialized on unexpected element:", this.element);
            return "about";
        },

        _getMenuLinks: function () {
            const selector = this.menuType === "services" ? "a" : "ul li a";
            return $(selector, this.wrap);
        },

        _checkActiveSection: function () {
            if (this._scrollingFromClick) return;

            const menuPos = $(window).scrollTop() + api.fn.getHeaderHeight() + 200;
            const sections = this._getSections();
            if (!sections || !sections.length) return;

            const activeId = this._findActiveSection(sections, menuPos);
            if (activeId) {
                this._updateActiveState(activeId);
                this._updateUrlHash(activeId);
            }
        },

        _getSections: function () {
            if (this.menuType === "about") {
                return $(".s-about__section");
            }

            if (this.menuType === "services") {
                const currentPanel = this.element.closest(".s-services__panel");
                return currentPanel.hasClass("is-visible") ? currentPanel.find(".s-services__section") : null;
            }

            return null;
        },

        _findActiveSection: function (sections, menuPos) {
            let activeId = null;

            sections.each((index, element) => {
                if (menuPos >= $(element).offset().top) {
                    activeId = $(element).attr("id");
                }
            });

            const scrollBottom = $(window).scrollTop() + $(window).height();
            if (scrollBottom >= $(document).height() - 5) {
                activeId = $(sections.last()).attr("id");
            }

            return activeId;
        },

        _updateActiveState: function (activeId) {
            const { removeSelector, addClass } = this._getActiveStateConfig();

            this.element.find(removeSelector).removeClass(addClass);

            const activeHref = this.element.find(`a[href="#${activeId}"]`);
            if (activeHref.length) {
                activeHref.addClass(addClass);
                if (this.menuType === "about") {
                    activeHref.closest("li").addClass(addClass);
                }
            }
        },

        _getActiveStateConfig: function () {
            const configs = {
                about: { removeSelector: "li, li a", addClass: "active" },
                services: { removeSelector: "a", addClass: "is-active" },
            };
            return configs[this.menuType] || configs.about;
        },

        _updateUrlHash: function (sectionId) {
            const currentHash = window.location.hash.substring(1);
            if (currentHash === sectionId) return;

            if (history.replaceState) {
                history.replaceState(null, "", "#" + sectionId);
            }
        },

        _stickyMenu: function () {
            if (!this._shouldApplySticky()) return;

            let $stickyTarget = this.element;
            let offsetTop = api.fn.getHeaderHeight();

            const $aboutLeft = this.element.closest(".s-about__left");
            if ($aboutLeft.length > 0) {
                const $column = $aboutLeft.closest('[class*="col-"]');
                if ($column.length > 0) {
                    $stickyTarget = $aboutLeft;
                } else {
                    $stickyTarget = this.element;
                    offsetTop += 80;
                }
            } else if (this.menuType === "services") {
                offsetTop += 80;
            }

            this._detachSticky($stickyTarget);

            $stickyTarget.stick_in_parent({
                offset_top: offsetTop,
            });
        },

        _shouldApplySticky: function () {
            if (this.menuType !== "services") return true;

            const currentPanel = this.element.closest(".s-services__panel");
            return currentPanel.hasClass("is-visible");
        },

        reinitializeSticky: function () {
            this._stickyMenu();
        },
    });
})(jQuery);
